<template>
  <v-card flat class="settings-card">
    <v-container>
      <v-card-title class="settings-header-text">Personal Details</v-card-title>
      <v-container>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                label="First Name"
                placeholder="First Name"
                v-model="firstName"
                readonly
                class="py-1"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Last Name"
                placeholder="Last Name"
                v-model="lastName"
                readonly
                class="py-1"
                dense
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Email"
                placeholder="Email"
                v-model="email"
                readonly
                class="py-1"
                dense
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Mobile Phone"
                placeholder="Add your mobile phone"
                v-model="mobilePhone"
                readonly
                class="py-1"
                dense
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-sheet>Contact an admin to change your personal details</v-sheet>
      </v-container>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "PersonalSettings",
  components: {},
  data: function() {
    return {
      hoverCheck: {}
    };
  },
  created() {},
  computed: {
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    adminUsers() {
      return this.$store.getters["entities/users/query"]()
        .where(user => {
          return user.authRoleId == 2;
        })
        .get();
    },
    adminName() {
      let names = this.adminUsers.map(user => {
        return user.longName + " (" + user.email + ")";
      });
      return names;
    },
    firstName() {
      return this.user ? this.user.firstName : "";
    },
    lastName() {
      return this.user ? this.user.lastName : "";
    },
    email() {
      return this.user ? this.user.email : "";
    },
    mobilePhone() {
      return this.user ? this.user.mobilePhoneNumber : "";
    }
  },
  methods: {
    saveButton(evt) {
      evt.preventDefault();
      let vueThis = this;
      this.$store.dispatch(
        "entities/bizReviewSettings/updateBizReviewsSettings",
        vueThis.reviewSettings
      );
    }
  }
};
</script>

<style scoped lang="stylus">
.settings-card {
  max-width: 40rem;
}
</style>
